import { getRoutes } from "./routes.config";

export type FooterItem = {
  id: string;
  testId: string;
  text: string;
  href?: string;
  lkid?: string;
  dataQA?: string;
};

export type FooterCategory = Record<string, FooterItem>;

export type FooterConfig = Record<string, FooterCategory>;

export function getFooterLinks(
  baseURL = "https://webmotors.com.br"
): FooterConfig {
  const ROUTES = getRoutes(baseURL);

  return {
    BUY: {
      USED_CARS: {
        id: "footer_buy_usedOrNewCars",
        testId: "footer_buy_usedOrNewCars",
        text: "Carros usados",
        href: `${ROUTES.CAR.USED}`,
        lkid: "1075",
        dataQA: "footer_buy_usedOrNewCars",
      },
      NEW_CARS: {
        id: "footer_buy_newCars",
        testId: "footer_buy_newCars",
        text: "Carros novos",
        href: ROUTES.CAR.NEW,
        lkid: "1076",
        dataQA: "footer_buy_newCars",
      },
      USED_BIKES: {
        id: "footer_buy_usedOrNewMotorbikes",
        testId: "footer_buy_usedOrNewMotorbikes",
        text: "Motos usadas",
        href: ROUTES.BIKE.USED,
        lkid: "1077",
        dataQA: "footer_buy_usedOrNewMotorbikes",
      },
      NEW_BIKES: {
        id: "footer_buy_newMotorbikes",
        testId: "footer_buy_newMotorbikes",
        text: "Motos novas",
        href: ROUTES.BIKE.NEW,
        lkid: "1078",
        dataQA: "footer_buy_newMotorbikes",
      },
      INSPECTED: {
        id: "footer_buy_inspected",
        testId: "footer_buy_inspected",
        text: "Vistoriado",
        href: `${ROUTES.CAR.ALL}?Oportunidades=Vistoriado`,
        lkid: "1578",
        dataQA: "footer_buy_inspected",
      },
    },
    SELL: {
      CAR: {
        id: "footer_sell_car",
        testId: "footer_sell_car",
        text: "Vender carro",
        href: ROUTES.CAR.SELL,
        lkid: "1080",
        dataQA: "footer_sell_car",
      },
      BIKE: {
        id: "footer_sell_bike",
        testId: "footer_sell_bike",
        text: "Vender moto",
        href: ROUTES.BIKE.SELL,
        lkid: "1081",
        dataQA: "footer_sell_bike",
      },
      GARAGE: {
        id: "footer_sell_manage_ad",
        testId: "footer_sell_manage_ad",
        text: "Gerenciar meu anúncio",
        href: ROUTES.GARAGE.BASE,
        lkid: "1082",
        dataQA: "footer_sell_manage_ad",
      },
      DEALER: {
        id: "footer_sell_dealer_platform",
        testId: "footer_sell_dealer_platform",
        text: "Plataforma revendedores",
        href: ROUTES.SERVICES.DEALER_PLATFORM,
        lkid: "1091",
        dataQA: "footer_sell_dealer_platform",
      },
    },
    SUBSCRIPTION: {
      VEHICLE_SUBSCRIPTION: {
        id: "footer_vehicle_subscription",
        testId: "footer_vehicle_subscription",
        text: "Carros por assinatura",
        href: ROUTES.SUBSCRIPTION,
        lkid: "3798",
      },
    },
    SERVICES: {
      SERVICES: {
        id: "footer_services_services",
        testId: "footer_services_services",
        text: "Serviços automotivos",
        href: ROUTES.SERVICES.SERVICES,
        lkid: "2474",
        dataQA: "footer_services_services",
      },
      FIPE: {
        id: "footer_services_fipe",
        testId: "footer_services_fipe",
        text: "Tabela FIPE e Tabela Webmotors",
        href: ROUTES.SERVICES.FIPE,
        lkid: "1084",
        dataQA: "footer_services_fipe",
      },
      FINANCING: {
        id: "footer_services_financing",
        testId: "footer_services_financing",
        text: "Financiamento",
        href: ROUTES.SERVICES.FINANCING,
        lkid: "1088",
        dataQA: "footer_services_financing",
      },
      CONSORCIO: {
        id: "footer_services_consorcio",
        testId: "footer_services_consorcio",
        href: ROUTES.SERVICES.CONSORCIO,
        text: "Consórcio",
        dataQA: "header_services_consorcio",
        lkid: "2301",
      },
      CAR_0KM: {
        id: "footer_services_catalog_0km",
        testId: "footer_services_catalog_0km",
        text: "Catálogo 0km",
        href: ROUTES.CAR.ZERO,
        lkid: "1085",
        dataQA: "footer_services_catalog_0km",
      },
      INSPECTED: {
        id: "footer_services_inspected",
        testId: "footer_services_inspected",
        text: "Vistoriado",
        href: `${ROUTES.COCKPIT}solutions/vistoriado`,
        lkid: "1579",
        dataQA: "footer_services_inspected",
      },
      DEALERS: {
        id: "footer_services_dealer_platform",
        testId: "footer_services_dealer_platform",
        text: "Plataforma revendedores",
        href: ROUTES.SERVICES.DEALER_PLATFORM,
        lkid: "1091",
        dataQA: "footer_services_dealer_platform",
      },
      INSURANCE: {
        id: "footer_services_insurance",
        testId: "footer_services_insurance",
        text: "Seguro veículo",
        href: ROUTES.SERVICES.INSURANCE,
        lkid: "1090&utm_source=webmotors&utm_medium=site&utm_campaign=footer_seguro_veiculo",
        dataQA: "footer_services_insurance",
      },
      ADVERTISING: {
        id: "footer_services_advertising",
        testId: "footer_services_advertising",
        text: "Webmotors Ads",
        href: ROUTES.SERVICES.ADVERTISING,
        lkid: "1092",
        dataQA: "footer_services_advertising",
      },
      COMPARE_VEHICLES: {
        id: "footer_services_compare_vehicles",
        testId: "footer_services_compare_vehicles",
        text: "Comparar veículos",
        href: ROUTES.SERVICES.COMPARE_VEHICLES,
        lkid: "1766",
        dataQA: "footer_services_compare_vehicles",
      },
      FINES_AND_DEBTS: {
        id: "footer_services_fines",
        testId: "footer_services_fines",
        text: "Multas e Débitos",
        href: ROUTES.SERVICES.FINES_AND_DEBTS,
        lkid: "1767",
        dataQA: "footer_services_fines",
      },
    },
    NEWS: {
      PORTAL: {
        id: "footer_wm1_portal",
        testId: "footer_wm1_portal",
        text: "Portal",
        href: ROUTES.WM1.PORTAL,
        lkid: "1531",
        dataQA: "footer_wm1_portal",
      },
      LASTNEWS: {
        id: "footer_wm1_lastnews",
        testId: "footer_wm1_lastnews",
        text: "Últimas notícias",
        href: ROUTES.WM1.LASTNEWS,
        lkid: "1532",
        dataQA: "footer_wm1_lastnews",
      },
      TESTS: {
        id: "footer_wm1_tests",
        testId: "footer_wm1_tests",
        text: "Testes",
        lkid: "1533",
        href: ROUTES.WM1.TESTS,
        dataQA: "footer_wm1_tests",
      },
      COMPARATIVES: {
        id: "footer_wm1_comparativos",
        testId: "footer_wm1_comparativos",
        text: "Comparativos",
        lkid: "1534",
        href: ROUTES.WM1.COMPARATIVES,
        dataQA: "footer_wm1_comparativos",
      },
      VIDEOS: {
        id: "footer_wm1_videos",
        testId: "footer_wm1_videos",
        text: "Vídeos",
        href: ROUTES.WM1.VIDEOS,
        lkid: "1535",
        dataQA: "footer_wm1_videos",
      },
      BIKES: {
        id: "footer_wm1_bikes",
        testId: "footer_wm1_bikes",
        text: "Motos",
        href: ROUTES.WM1.BIKES,
        lkid: "1536",
        dataQA: "footer_wm1_bikes",
      },
      SECRETS: {
        id: "footer_wm1_secrets",
        testId: "footer_wm1_secrets",
        text: "Segredos",
        href: ROUTES.WM1.SECRETS,
        lkid: "1537",
        dataQA: "footer_wm1_secrets",
      },
      TIPS: {
        id: "footer_wm1_tips",
        testId: "footer_wm1_tips",
        text: "Dicas",
        href: ROUTES.WM1.TIPS,
        lkid: "1538",
        dataQA: "footer_wm1_tips",
      },
      POCKET: {
        id: "footer_wm1_pocket",
        testId: "footer_wm1_pocket",
        text: "Bolso",
        href: ROUTES.WM1.POCKET,
        lkid: "1539",
        dataQA: "footer_wm1_pocket",
      },
    },
    HELP: {
      YOU: {
        id: "footer_help_you",
        testId: "footer_help_you",
        text: "Para você",
        href: ROUTES.HELP.YOU,
        lkid: "1093",
        dataQA: "footer_help_you",
      },
      HOW_TO_BUY: {
        id: "footer_help_store",
        testId: "footer_help_store",
        text: "Para a sua loja",
        href: ROUTES.HELP.HOW_TO_BUY,
        lkid: "1096",
        dataQA: "footer_help_store",
      },
      SECURITY: {
        id: "footer_help_security",
        testId: "footer_help_security",
        text: "Segurança",
        href: ROUTES.HELP.SECURITY,
        lkid: "2172",
        dataQA: "footer_help_security",
      },
      INSTITUCIONAL: {
        id: "footer_help_institutional",
        testId: "footer_help_institutional",
        text: "Quem somos",
        href: ROUTES.HELP.INSTITUCIONAL,
        lkid: "1542",
        dataQA: "footer_help_institutional",
      },
      WORK_WITH_US: {
        id: "footer_help_workWithUs",
        testId: "footer_help_workWithUs",
        text: "Trabalhe com a gente",
        href: ROUTES.HELP.WORK_WITH_US,
        lkid: "1099",
        dataQA: "footer_help_workWithUs",
      },
      SITEMAP: {
        id: "footer_help_siteMap",
        testId: "footer_help_siteMap",
        text: "Mapa do site",
        href: ROUTES.HELP.SITEMAP,
        lkid: "1543",
        dataQA: "footer_help_siteMap",
      },
    },
    INSTITUTIONAL: {
      ALO_ETICA: {
        id: "footer_institutional_ethic",
        testId: "footer_institutional_ethic",
        text: "Canal de Denúncias",
        href: ROUTES.INSTITUTIONAL.ALO_ETICA,
        lkid: "1544",
        dataQA: "footer_institutional_ethic",
      },
      CONDUCT_CODE: {
        id: "footer_institutional_conductCode",
        testId: "footer_institutional_conductCode",
        text: "Código de conduta Webmotors",
        href: ROUTES.INSTITUTIONAL.CONDUCT_CODE,
        lkid: "1545",
        dataQA: "footer_institutional_conductCode",
      },
      SUPPLIER_CONDUCT_CODE: {
        id: "footer_institutional_supplierConductCode",
        testId: "footer_institutional_supplierConductCode",
        text: "Código de Conduta Fornecedores",
        href: ROUTES.INSTITUTIONAL.SUPPLIER_CONDUCT_CODE,
        lkid: "2122",
        dataQA: "footer_institutional_supplierConductCode",
      },
      CONSUMER: {
        id: "footer_institutional_consumerPolicy",
        testId: "footer_institutional_consumerPolicy",
        text: "Código defesa do consumidor",
        href: ROUTES.INSTITUTIONAL.CONSUMER,
        lkid: "1097",
        dataQA: "footer_institutional_consumerPolicy",
      },
      COOKIES: {
        id: "footer_institutional_cookiesManagement",
        testId: "footer_institutional_cookiesManagement",
        text: "Gerenciamento de cookies",
        href: undefined,
        lkid: "",
        dataQA: "footer_institutional_cookiesManagement",
      },
      PRIVACY: {
        id: "footer_institutional_privacyPolicy",
        testId: "footer_institutional_privacyPolicy",
        text: "Termos de Uso e Política de privacidade",
        lkid: "1546",
        href: ROUTES.INSTITUTIONAL.PRIVACY,
        dataQA: "footer_institutional_privacyPolicy",
      },
      LGPD: {
        id: "footer_institutional_lgpd",
        testId: "footer_institutional_lgpd",
        text: "LGPD",
        href: ROUTES.INSTITUTIONAL.LGPD,
        lkid: "1548",
        dataQA: "footer_institutional_lgpd",
      },
      LGPD_BOOK: {
        id: "footer_institutional_lgpd_book",
        testId: "footer_institutional_lgpd_book",
        text: "Cartilha LGPD",
        href: ROUTES.INSTITUTIONAL.LGPD_BOOK,
        lkid: "",
        dataQA: "footer_institutional_lgpd_book",
      },
      TRANSPARENCY: {
        id: "footer_institutional_transparency",
        testId: "footer_institutional_transparency",
        text: "Relatório de Transparência",
        href: ROUTES.INSTITUTIONAL.TRANSPARENCY,
        lkid: "",
        dataQA: "footer_institutional_transparency",
      },
    },
    SOCIAL: {
      INSTAGRAM: {
        id: "footer_social_instagram",
        testId: "footer_social_instagram",
        text: "Instagram",
        href: ROUTES.SOCIAL.INSTAGRAM,
        lkid: "",
        dataQA: "footer_social_instagram",
      },
      FACEBOOK: {
        id: "footer_social_facebook",
        testId: "footer_social_facebook",
        text: "Facebook",
        href: ROUTES.SOCIAL.FACEBOOK,
        lkid: "",
        dataQA: "footer_social_facebook",
      },
      YOUTUBE: {
        id: "footer_social_youtube",
        testId: "footer_social_youtube",
        text: "Youtube",
        href: ROUTES.SOCIAL.YOUTUBE,
        lkid: "",
        dataQA: "footer_social_youtube",
      },
      LINKEDIN: {
        id: "footer_social_linkedin",
        testId: "footer_social_linkedin",
        text: "LinkedIn",
        href: ROUTES.SOCIAL.LINKEDIN,
        lkid: "",
        dataQA: "footer_social_linkedin",
      },
      X: {
        id: "footer_social_x",
        testId: "footer_social_x",
        text: "X",
        href: ROUTES.SOCIAL.X,
        lkid: "",
        dataQA: "footer_social_x",
      },
      TIKTOK: {
        id: "footer_social_tiktok",
        testId: "footer_social_tiktok",
        text: "TikTok",
        href: ROUTES.SOCIAL.TIKTOK,
        lkid: "",
        dataQA: "footer_social_tiktok",
      },
    },
  };
}
